import { zUsdCents } from "@redotech/redo-billing-common/currency";
import * as z from "zod";

export const getBaseSupportPredictedPriceInfo = {
  name: "getBaseSupportPredictedPriceInfo" as const,
  input: z.null(),
  output: z.object({
    pricingTiers: z.array(
      z.object({ numTickets: z.number(), priceInCents: zUsdCents }),
    ),
    currentBucketIndex: z.number(),
  }),
};
